import { Component, Inject, OnInit, EventEmitter, Input } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { DLogger, DValidaciones } from '@dian/core';
import { DCalc } from '../../../../utils/dcalc';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['680'] }
];

const tableStructure = [
  { id: 'pagador681', title: 'Nombre pagador' },
  { id: 'origen', title: 'Origen información' },
  { id: 'textoConcepto', title: 'Concepto' },
  { id: 'textoTipoDeRenta', title: 'Tipo de Renta' },
  // { id: 'tipoDeRenta', title: 'Tipo de Renta' },
  { id: 'valor685', title: 'Valor a declarar' },
];


class Form1 {
  id: number;
  idSugerida: number;
  pagador681: string;  //681
  origen: string;  //682
  concepto683: string;  //683
  textoConcepto: string;
  tipoDeRenta684: string;  //684 
  textoTipoDeRenta: string;
  valor685: string;  //685
  limitesRAIS691: string;  //691
  seccionOrigen: string;  //Historia de usuario desde la que vienen los datos
  deshabilitarAcci: boolean;  //deshabilita editar y eliminar en la tabla

  // vlg_RAIS_asal676: string;
  // vlg_RAIS_indep_cap677: string;
  // vlg_RAIS_rent_cap678: string;
  // vlg_RAIS_rent_no_lab679: string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-beneficios-ingresos-no-gravados-modal',
  templateUrl: './beneficios-ingresos-no-gravados-modal.component.html',
  styleUrls: ['./beneficios-ingresos-no-gravados-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class BeneficiosIngresosNoGravados extends HandlerModal implements OnInit {


  @Input('listaConceptosIngreNoGravados') listaConceptosIngreNoGravados: any;
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public listaConcepto: any[] = [];
  public listaConcepto2: any[] = [];
  public listaTipoDeRenta: any[] = [];
  public listaTipoDeRenta2: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  calc: DCalc;

  uvt: any;
  saveModel = new EventEmitter();
  public showSave: boolean;
  tablaArt73: any;
  listaModoAdquisicion: any;
  model: DDocumento;
  mdc: any
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<BeneficiosIngresosNoGravados>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.calc = new DCalc(this.dutilidades);
    this.model = this.data.model;
    this.mdc = this.model.doc.cuerpo;

    //this.model = this.data;
    console.log(this.model);
  }

  ngOnInit() {
    this.prueba()
    this.inicializeModelo();
    this.inicializeForm();
    this.generarListaConcepto();
    this.reloadSelArticulos();
    this.obtenerEliminarDataTrabInd();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida(); 
    this.cargarDatosOtrosModales(true); 
    // this.guardadoPreventivo();
    this.validateShowSave();
    // this.initializeAnios();
    console.log('modelo al abrir ingresos no gravados: ', this.model);
  }

    
  // private guardadoPreventivo() {
  //   this.mdc.cc_id_681 = undefined;
  //   this.inicializeModelo();
  //   for (let i = 0; i < this.dataSourceBody.length; i++) {
  //     this.modelForm = this.dataSourceBody[i];
  //     this.modelForm.valor685 = this.dutilidades.deshacerFormatoMoneda(this.modelForm.valor685);
  //     console.log(this.modelForm);
  //     this.addToModeloDesdeForm();
  //   }

  //   // this.operacionCS691(); //ya se calculó
  //   // this.operacionCS676(); //ya se calculó

  //   this.saveModel.emit(true);
  // }

  prueba() {
    let a = '10';
    let b = '10';
    let c = '7';
    let d = '3';
    console.log(`${a} + ${b} = ${this.calc.suma(a, b)}`)
    console.log(`${a} - ${b} = ${this.calc.resta(a, b)}`)
    console.log(`${a} x ${c} = ${this.calc.mult(a, c)}`)
    console.log(`${a} / ${d} = ${this.calc.div(a, d)}`)
    console.log(`${a} /entera ${d} = ${this.calc.div_int(a, d)}`)
    console.log(`${a} == ${b} = ${this.calc.esIgual(a, b)}`)
    console.log(`${a} > ${c} = ${this.calc.esMayor(a, c)}`)
    console.log(`${a} < ${c} = ${this.calc.esMenor(a, c)}`)
    console.log(`${a} <= ${b} = ${this.calc.esMenorOIgual(a, b)}`)
    console.log(`${a} >= ${b} = ${this.calc.esMayorOIgual(a, b)}`)
    console.log(`${a} != ${b} = ${this.calc.esDif(a, b)}`)
    console.log(`${a} != ${c} = ${this.calc.esDif(a, c)}`)
    console.log(`mayor entre ${a} y ${c} = ${this.calc.max(a, c)}`)
    console.log(`menor entre ${a} y ${c} = ${this.calc.min(a, c)}`)
  }

  generarListaConcepto() {

    for (const fila of this.listaConceptosIngreNoGravados) {
      if (fila.valor && fila.valor!='11') {
        this.listaConcepto2.push({ valor: fila.valor, nombre: fila.nombre, show: true });
      }
      this.listaConcepto.push({ valor: fila.valor, nombre: fila.nombre, show: true });
    }

    this.listaConcepto.sort((a, b) => a.valor - b.valor);
    console.log('listaConcepto: ', this.listaConcepto);

  }



  protected controlStep(direction: DirectionType): void {

  }


  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.idSugerida = 0;

    this.modelForm.pagador681 = "";//pagador  //681
    this.modelForm.origen = "";//origen  //682
    this.modelForm.concepto683 = "";//concepto:  //683
    this.modelForm.tipoDeRenta684 = ""; //tipoDeRenta  //684 
    this.modelForm.valor685 = "0";//valor  //685
    this.modelForm.limitesRAIS691 = "0";//limitesRAIS  //691
    this.modelForm.seccionOrigen = "";//sección origen

    // this.modelForm.vlg_RAIS_asal676 = '0';
    // this.modelForm.vlg_RAIS_indep_cap677 = '0';
    // this.modelForm.vlg_RAIS_rent_cap678 = '0';
    // this.modelForm.vlg_RAIS_rent_no_lab679 = '0';


    this.reloadSelArticulos();
  }

  protected inicializeModelo() {
    if (this.mdc.cc_id_681 == undefined) {

      this.mdc.cc_id_681 = [];//pagador  //681
      this.mdc.cc_id_682 = [];//origen  //682
      this.mdc.cc_id_683 = [];//concepto:  //683
      this.mdc.cc_id_684 = [];//tipoDeRenta  //684 
      this.mdc.cc_id_685 = [];//valor  //685
      this.mdc.cc_id_691 = [];//Límites RAIS  //691 = [];//Límite RAIS
      this.mdc.cc_id_687 = [];//sección origen

      this.mdc.cs_id_676 = "0";//limitante trabajo con costo
      this.mdc.cs_id_677 = "0";//limitante renta capital
      this.mdc.cs_id_678 = "0";//limitante renta no laboral
      this.mdc.cs_id_679 = "0";//limitante renta no laboral
      this.mdc.cs_id_691 = this.mdc.cs_id_691 ? this.mdc.cs_id_691 : "0";

      this.mdc.cs_id_686 = this.mdc.cs_id_686 ? this.mdc.cs_id_686 : "0";

    }
  }

  protected reloadSelArticulos(conservarArt?: boolean) {

    /*
        Concepto	                                            Tipo de renta
    
      1  Aportes obligatoria a salud	                          3 Renta de capital
                                                               4 Rentas no laborales
                                                              5 Pensión
      _______________________________________________________________________________________    
                                                              
      2  Aporte obligatorio a pensión	                        3 Renta de capital
                                                               4 Rentas no laborales
      _______________________________________________________________________________________    
    
      3  Cotización voluntaria RAIS 	                        2 Renta de trabajo con costo
                                                              3 Renta de capital
                                                               4 Rentas no laborales
      _______________________________________________________________________________________    
    
      4  Daño emergente	                                       4 Rentas no laborales
      _______________________________________________________________________________________    
    
      5  Acciones BIC	                                        1 Renta de trabajo SIN costo
      _______________________________________________________________________________________    
    
      6  Apoyos económicos ­	                                    4 Rentas no laborales
      _______________________________________________________________________________________    
    
      7  Aportes ARL	                                          3 Renta de capital
                                                                4 Rentas no laborales
      _______________________________________________________________________________________    
      8  Gananciales	                                          7 Ganancias Ocasional
      _______________________________________________________________________________________    
        
      9  Ingresos proyectos científicos, innovación	           4 Rentas no laborales
      _______________________________________________________________________________________    
        
     10  Pagos proyectos científicos, innovación	              1 Renta de trabajo SIN costo
    _______________________________________________________________________________________    
     11  Componente inflac.       	                            3 Renta de capital
        
    */



    console.log('reloadSelArticulos');

    this.listaTipoDeRenta[0] = { valor: 1, nombre: "Rentas de trabajo sin costo", show: true };
    this.listaTipoDeRenta[1] = { valor: 2, nombre: "Rentas de trabajo con costo", show: true };
    this.listaTipoDeRenta[2] = { valor: 3, nombre: "Rentas de capital", show: true };
    this.listaTipoDeRenta[3] = { valor: 4, nombre: "Rentas no laborales", show: true };
    this.listaTipoDeRenta[4] = { valor: 5, nombre: "Pensión", show: true };
    this.listaTipoDeRenta[5] = { valor: 6, nombre: "Dividendos", show: true };
    this.listaTipoDeRenta[6] = { valor: 7, nombre: "Ganancia Ocasional", show: true };
    this.listaTipoDeRenta[7] = { valor: 8, nombre: "Utilidades acciones BIC", show: true };
    this.listaTipoDeRenta[8] = { valor: 9, nombre: "Proyectos científicos tecnológicos o de innovación", show: true };





    this.listaTipoDeRenta2[0] = { valor: 1, nombre: "Rentas de trabajo sin costo" };
    this.listaTipoDeRenta2[1] = { valor: 2, nombre: "Rentas de trabajo con costo" };
    this.listaTipoDeRenta2[2] = { valor: 3, nombre: "Rentas de capital" };
    this.listaTipoDeRenta2[3] = { valor: 4, nombre: "Rentas no laborales" };
    this.listaTipoDeRenta2[4] = { valor: 5, nombre: "Pensión" };
    this.listaTipoDeRenta2[5] = { valor: 6, nombre: "Dividendos" };
    this.listaTipoDeRenta2[6] = { valor: 7, nombre: "Ganancia Ocasional" };
    this.listaTipoDeRenta2[7] = { valor: 8, nombre: "Utilidades acciones BIC" };
    this.listaTipoDeRenta2[8] = { valor: 9, nombre: "Proyectos científicos tecnológicos o de innovación" };

    // if (this.modelForm.concepto == '6' || this.modelForm.concepto == '8' || this.modelForm.concepto == '10') {
    this.listaTipoDeRenta.forEach(item => {
      item.show = false;
    });
    if (
      this.modelForm.concepto683 == '5' ||
      this.modelForm.concepto683 == '10') {
      this.listaTipoDeRenta.forEach(item => {
        if (item.valor != 1) {
          // item.show = false;
        } else {
          item.show = true;
        }
      });
    }
    if (
      this.modelForm.concepto683 == '3') {
      this.listaTipoDeRenta.forEach(item => {
        if (item.valor != 2) {
          // item.show = false;
        } else {
          item.show = true;
        }
      });
    }
    if (
      this.modelForm.concepto683 == '1' ||
      this.modelForm.concepto683 == '2' ||
      this.modelForm.concepto683 == '3' ||
      this.modelForm.concepto683 == '7' ||
      this.modelForm.concepto683 == '11') {
      this.listaTipoDeRenta.forEach(item => {
        if (item.valor != 3) {
          // item.show = false;
        } else {
          item.show = true;
        }
      });
    }

    if (
      this.modelForm.concepto683 == '1' ||
      this.modelForm.concepto683 == '2' ||
      this.modelForm.concepto683 == '3' ||
      this.modelForm.concepto683 == '4' ||
      this.modelForm.concepto683 == '6' ||
      this.modelForm.concepto683 == '7'
      || this.modelForm.concepto683 == '9') {
      this.listaTipoDeRenta.forEach(item => {
        if (item.valor != 4) {
          // item.show = false;
        } else {
          item.show = true;
        }
      });
    }
    if (this.modelForm.concepto683 == '1') {
      this.listaTipoDeRenta.forEach(item => {
        if (item.valor != 5) {
          // item.show = false;
        } else {
          item.show = true;
        }
      });
    }
    if (this.modelForm.concepto683 == '8') {
      this.listaTipoDeRenta.forEach(item => {
        if (item.valor != 7) {
          // item.show = false;
        } else {
          item.show = true;
        }
      });
    }

  }



  public operacionCs686() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      //if(this.dataSourceBody[i].origen == "2")
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor685, suma);
      /*   else
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valCatastral, suma); */
    }
    if (suma)
      this.mdc.cs_id_686 = suma;
    else
      this.mdc.cs_id_686 = '0';
  }



  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;

    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }

  operacionCS158() {
    this.mdc.cs_id_158 = this.dutilidades.redondearValorMoneda(this.mdc.cs_id_158, true);
  }


  //////////////////////

  protected initializeTablaDesdeModelo() {



    this.dataSourceBody = [];
    if (this.mdc.cc_id_681 != undefined && this.mdc.cc_id_681 != null) {
      for (let i = 0; i < this.mdc.cc_id_683.length; i++) {
        this.modelForm.id = i;
        this.modelForm.pagador681 = this.mdc.cc_id_681[i].v; //pagador  //681
        this.modelForm.origen = this.mdc.cc_id_682[i].v;//origen  //682
        this.modelForm.concepto683 = this.mdc.cc_id_683[i].v;//concepto:  //683
        if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
          this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
        }
        // if (this.listaConcepto[this.mdc.cc_id_683[i].v - 1])
        //   this.modelForm.textoConcepto = this.listaConcepto[this.mdc.cc_id_683[i].v - 1].nombre;
        this.modelForm.tipoDeRenta684 = this.mdc.cc_id_684[i].v;//tipoDeRenta  //684 
        // this.reloadSelArticulos();
        if (this.listaTipoDeRenta && this.listaTipoDeRenta.length > 0) {
          this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2.find(item => item.valor.toString() == this.modelForm.tipoDeRenta684).nombre;
        }
        // if(this.listaTipoDeRenta2[this.mdc.cc_id_684[i].v])
        //   this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[Number(this.mdc.cc_id_684[i].v)-1].nombre;
        this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_685[i].v);//valor  //685
        // this.modelForm.seccionOrigen = this.mdc.cc_id_687[i].v;//valor  //687

        if (this.mdc.cc_id_687[i].v != undefined && this.mdc.cc_id_687[i].v != "") {
          this.modelForm.seccionOrigen = this.mdc.cc_id_687[i].v;
        }
        else {
          this.modelForm.seccionOrigen = "";
        }

        this.modelForm.deshabilitarAcci = this.modelForm.seccionOrigen != "" ? true : false;

        // this.modelForm.limitesRAIS691 = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length > 0) ? this.mdc.cc_id_691[i].v : "0";//Límites RAIS  //691[i].v;//Límites RAIS  //691


        this.dataSourceBody.push(this.modelForm);
        this.inicializeForm();
      }

    }


  }
  // _________________________________________________________________________________________________________///////////////////////


  // mapeoAsalariadoOFuncionarioPublico=[
  //   ['287','277','278','1','1','287'],
  //   ['288','277','278','2','1','288'],
  //   ['289','277','278','3','1','289'],
  //   ['292','277','278','6','1','292'],

  //   ]
  //   mapeoTrabajadorIndependiente=[
  //     ['313','309','302','1','303','313'],
  //     ['312','309','302','2','303','313'],
  //     ['316','309','302','9','303','316'],
  //   ];
  //   mapeoIngrArrRendFinan=[
  //     ['333','309','302','5','3','333']
  //   ];

  cargarDatosOtrosModales(desdeSeccion: boolean) {

    // casilla 287>0 Aporte obligatorios pensión RENTAS DE TRABAJO SIN COSTOS
    this.cargarDesdeApoOblPensAsalariado(desdeSeccion);

    // casilla 288>0 Aporte salud RENTAS DE TRABAJO SIN COSTOS
    this.cargarDesdeApoSalAsalariado(desdeSeccion);

    // casilla 289>0 cotizaciones voluntarias RAIS RENTAS DE TRABAJO SIN COSTOS
    this.cargarDesdeCotiVolRAISAsalariado(desdeSeccion);

    // casilla 292>0 apoyos económicos educativos RENTAS DE TRABAJO SIN COSTOS
    this.cargarDesdeApoEcoEduAsalariado(desdeSeccion);


    // casilla 313>0 Aporte Obligatorio pensión Trabajador independiente
    this.cargarDesdeApoPensionIndependiente(desdeSeccion);

    // casilla 312>0 Aporte a salud  Trabajador independiente
    this.cargarDesdeApoSaludIndependiente(desdeSeccion);

    // casilla 316>0 Aporte ARL  Trabajador independiente
    this.cargarDesdeApoARLIndependiente(desdeSeccion);

    // casilla 333>0 Aporte ARL  Trabajador independiente 
    // parte no gravada de rentas de capital
    this.cargarDesdePartNoGravRentCap(desdeSeccion);

    //casilla 317>0 Cotización voluntaria RAIS Trabajador Independiente
    this.cargarDesdeCotiVolRAISIndependiente(desdeSeccion);

    // venta de vivienda
    //casilla 510 (costo fiscal)= 523 (Art 44 E.T.) => casilla 522 (utilidad)



    this.operacionCs686(); //calcula total

  }

  obtenerEliminarDataTrabInd(){
    if(this.model.doc.cuerpo.cc_id_687 != undefined 
      && this.model.doc.cuerpo.cc_id_687 != null){

        const posicionesTrabInd = this.model.doc.cuerpo.cc_id_687.reduce((acc, item, index) => {
          if (item.v != '') {
              acc.push(index);
          }
          return acc;
      }, []);

      posicionesTrabInd.sort((a, b) => b - a).forEach(index => {
        this.deleteOnModel(index)
      });
    }
  }

  private cargarDesdeApoOblPensAsalariado(desdeSeccion: boolean) {
    if (this.mdc.cc_id_287 != undefined
      && this.mdc.cc_id_287 != null) {

      const posicionesAsalariadoPension = this.mdc.cc_id_287
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);
      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_277.length;

      if (posicionesAsalariadoPension.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }

        for (let i = 0; i < posicionesAsalariadoPension.length; i++) {
          const indexAsalariado = posicionesAsalariadoPension[i];
          // const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_277[indexAsalariado].v);

          //if (!existeValor) {
            this.modelForm.id = indexTable;
            this.modelForm.pagador681 = this.mdc.cc_id_277[indexAsalariado].v; //pagador  //277
            this.modelForm.origen = this.mdc.cc_id_278[indexAsalariado].v; //origen  //278
            this.modelForm.concepto683 = '2'; //concepto:  //683
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '1'; //tipoDeRenta  //684 rentas de trabajo sin costo
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[0].nombre;
            }
            this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_287[indexAsalariado].v); //valor  //685

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexAsalariado].v : "0";//Límites RAIS  //691[indexAsalariado].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I1";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;

          //}

        }
      }
    }
  }

  private cargarDesdeApoSalAsalariado(desdeSeccion: boolean) {
    if (this.mdc.cc_id_288 != undefined
      && this.mdc.cc_id_288 != null) {

      const posicionesAsalariadoSalud = this.mdc.cc_id_288
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);
      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_277.length;

      if (posicionesAsalariadoSalud.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }
        for (let i = 0; i < posicionesAsalariadoSalud.length; i++) {
          const indexAsalariado = posicionesAsalariadoSalud[i];
          // const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_277[indexAsalariado].v);

         // if (!existeValor) {
            this.modelForm.id = indexTable;
            this.modelForm.pagador681 = this.mdc.cc_id_277[indexAsalariado].v; //pagador  //277
            this.modelForm.origen = this.mdc.cc_id_278[indexAsalariado].v; //origen  //278
            this.modelForm.concepto683 = '1'; //concepto:  //683
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '1'; //tipoDeRenta  //684 1.rentas de trabajo sin costo
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[0].nombre;
            }
            this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_288[indexAsalariado].v); //valor  //288

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexAsalariado].v : "0";//Límites RAIS  //691[indexAsalariado].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I1";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;

          //}

        }
      }
    }
  }

  private cargarDesdeCotiVolRAISAsalariado(desdeSeccion: boolean) {
    if (this.mdc.cc_id_289 != undefined
      && this.mdc.cc_id_289 != null) {

      const posicionesAsalariadoRAIS = this.mdc.cc_id_289
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);
      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_277.length;


      if (posicionesAsalariadoRAIS.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }
        for (let i = 0; i < posicionesAsalariadoRAIS.length; i++) {
          const indexAsalariado = posicionesAsalariadoRAIS[i];
          // const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_277[indexAsalariado].v);

          //if (!existeValor) {
            this.modelForm.id = indexTable;
            this.modelForm.pagador681 = this.mdc.cc_id_277[indexAsalariado].v; //pagador  //277
            this.modelForm.origen = this.mdc.cc_id_278[indexAsalariado].v; //origen  //278
            this.modelForm.concepto683 = '3'; //concepto:  //683
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '1'; //tipoDeRenta  //684 
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[0].nombre;
            }

            // SI Cas 289 (Cotizaciones voluntarias RAIS Asalariado)> 0; Cas 295;Limitante RAIS Asalariado
            let cc289MenorIgualcc295 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.mdc.cc_id_289[indexAsalariado].v, this.mdc.cc_id_295[indexAsalariado].v);
            if (cc289MenorIgualcc295) {
              this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_289[indexAsalariado].v); //valor  //288
            }
            if (!cc289MenorIgualcc295) {
              this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_295[indexAsalariado].v); //valor  //288
            }

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexAsalariado].v : "0";//Límites RAIS  //691[indexAsalariado].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I1";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;

         // }

        }
      }
    }
  }

  private cargarDesdePartNoGravRentCap(desdeSeccion: boolean) {
    if (this.mdc.cc_id_333 != undefined
      && this.mdc.cc_id_333 != null) {

      const posicionesRentasDeCapital = this.mdc.cc_id_333
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);
      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_324.length;

      if (posicionesRentasDeCapital.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }
        for (let i = 0; i < posicionesRentasDeCapital.length; i++) {
          const indexRentasCapital = posicionesRentasDeCapital[i];
          console.log('this.mdc.cc_id_324:',this.mdc.cc_id_324);
          // let existeValor;
          // if (this.mdc.cc_id_324.length>0) {
          //    existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_324[indexRentasCapital].v);
          // }else{
          //    existeValor=false;
          // }

          //if (!existeValor) {
            this.modelForm.id = indexTable;
            if (this.mdc.cc_id_324.length > i) { this.modelForm.pagador681 = this.mdc.cc_id_324[indexRentasCapital].v; } else { this.modelForm.pagador681 = ''; } //pagador  //325
            if (this.mdc.cc_id_325.length > i) { this.modelForm.origen = this.mdc.cc_id_325[indexRentasCapital].v; } else { this.modelForm.origen = '1'; } //origen  //278
            this.modelForm.concepto683 = '11'; //concepto:  //683 
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '3'; //tipoDeRenta  //684 2. rentas de trabajo con costo
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[2].nombre;
            }
            if (this.mdc.cc_id_333.length > i) {
              this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_333[indexRentasCapital].v);
            } else {
              this.modelForm.valor685 = '0';
            } //valor  //313

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexRentasCapital].v : "0";//Límites RAIS  //691[indexRentasCapital].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I3";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;


          //}
        }


      }

    }
  }

  private cargarDesdeApoARLIndependiente(desdeSeccion: boolean) {
    if (this.mdc.cc_id_316 != undefined
      && this.mdc.cc_id_316 != null) {

      const posicionesIndependienteARL = this.mdc.cc_id_316
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);
      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_309.length;

      if (posicionesIndependienteARL.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }
        for (let i = 0; i < posicionesIndependienteARL.length; i++) {
          const indexIndependiente = posicionesIndependienteARL[i];
          // const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_309[indexIndependiente].v);

          //if (!existeValor) {
            this.modelForm.id = indexTable;
            this.modelForm.pagador681 = this.mdc.cc_id_309[indexIndependiente].v; //pagador  //277
            this.modelForm.origen = this.mdc.cc_id_302[indexIndependiente].v; //origen  //278
            this.modelForm.concepto683 = '7'; //concepto:  //683
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '2'//this.mdc.cc_id_303[indexIndependiente].v; //tipoDeRenta  //684 
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2.find(item => item.valor.toString() == this.modelForm.tipoDeRenta684).nombre;
            }
            this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_316[indexIndependiente].v); //valor  //313

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexIndependiente].v : "0";//Límites RAIS  //691[indexIndependiente].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I2";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;

         // }
        }
      }
    }
  }

  private cargarDesdeApoSaludIndependiente(desdeSeccion: boolean) {
    if (this.mdc.cc_id_312 != undefined
      && this.mdc.cc_id_312 != null) {

      const posicionesIndependienteSalud = this.mdc.cc_id_312
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);
      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_309.length;

      if (posicionesIndependienteSalud.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }
        for (let i = 0; i < posicionesIndependienteSalud.length; i++) {
          const indexIndependiente = posicionesIndependienteSalud[i];
          // const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_309[indexIndependiente].v);

          //if (!existeValor) {
            this.modelForm.id = indexTable;
            this.modelForm.pagador681 = this.mdc.cc_id_309[indexIndependiente].v; //pagador  //277
            this.modelForm.origen = this.mdc.cc_id_302[indexIndependiente].v; //origen  //278
            this.modelForm.concepto683 = '1'; //concepto:  //683 
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '2'//this.mdc.cc_id_303[indexIndependiente].v; //tipoDeRenta  //684 
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[Number(this.mdc.cc_id_303[indexIndependiente].v)].nombre;
            }
            this.modelForm.valor685 = (this.mdc.cc_id_312[indexIndependiente].v); //valor  //313

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexIndependiente].v : "0";//Límites RAIS  //691[indexIndependiente].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I2";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;

          //}
        }
      }
    }
  }

  private cargarDesdeApoPensionIndependiente(desdeSeccion: boolean) {
    if (this.mdc.cc_id_313 != undefined
      && this.mdc.cc_id_313 != null) {

      const posicionesIndependientePension = this.mdc.cc_id_313
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);
      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_309.length;

      if (posicionesIndependientePension.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }
        for (let i = 0; i < posicionesIndependientePension.length; i++) {
          const indexIndependiente = posicionesIndependientePension[i];
          // const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_309[indexIndependiente].v);

         // if (!existeValor) {
            this.modelForm.id = indexTable;
            this.modelForm.pagador681 = this.mdc.cc_id_309[indexIndependiente].v; //pagador  //277
            this.modelForm.origen = this.mdc.cc_id_302[indexIndependiente].v; //origen  //278
            this.modelForm.concepto683 = '2'; //concepto:  //683 rentas de trabajo con costo
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '2'//this.mdc.cc_id_303[indexIndependiente].v; //tipoDeRenta  //684 
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2.find(item => item.valor.toString() == this.modelForm.tipoDeRenta684).nombre;
            }
            this.modelForm.valor685 = this.mdc.cc_id_313[indexIndependiente].v; //valor  //313

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexIndependiente].v : "0";//Límites RAIS  //691[indexIndependiente].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I2";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;

         // }
        }
      }
    }
  }

  private cargarDesdeApoEcoEduAsalariado(desdeSeccion: boolean) {
    if (this.mdc.cc_id_292 != undefined
      && this.mdc.cc_id_292 != null) {

      const posicionesAsalariadoApoyoEdu = this.mdc.cc_id_292
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);

      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_277.length;

      if (posicionesAsalariadoApoyoEdu.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }

        for (let i = 0; i < posicionesAsalariadoApoyoEdu.length; i++) {
          const indexAsalariado = posicionesAsalariadoApoyoEdu[i];
          // const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_277[indexAsalariado].v);

          //if (!existeValor) {
            this.modelForm.id = indexTable;
            this.modelForm.pagador681 = this.mdc.cc_id_277[indexAsalariado].v; //pagador  //277
            this.modelForm.origen = this.mdc.cc_id_278[indexAsalariado].v; //origen  //278
            this.modelForm.concepto683 = '6'; //concepto:  //683
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '1'; //tipoDeRenta  //684 
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[0].nombre;
            }
            this.modelForm.valor685 = (this.mdc.cc_id_292[indexAsalariado].v); //valor  //288

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexAsalariado].v : "0";//Límites RAIS  //691[indexAsalariado].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I1";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;

          //}
        }

      }
    }
  }


  private cargarDesdeCotiVolRAISIndependiente(desdeSeccion: boolean) {
    if (this.mdc.cc_id_317 != undefined
      && this.mdc.cc_id_317 != null) {

      const posicionesIndependienteRAIS = this.mdc.cc_id_317
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);
      let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_309.length;


      if (posicionesIndependienteRAIS.length > 0) {
        if (!desdeSeccion) { this.inicializeForm(); }
        for (let i = 0; i < posicionesIndependienteRAIS.length; i++) {
          const indexIndependiente = posicionesIndependienteRAIS[i];
          // const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_309[indexIndependiente].v);

          //if (!existeValor) {
            this.modelForm.id = indexTable;
            this.modelForm.pagador681 = this.mdc.cc_id_309[indexIndependiente].v; //pagador  //309
            this.modelForm.origen = this.mdc.cc_id_302[indexIndependiente].v; //origen  //302
            this.modelForm.concepto683 = '3'; //concepto:  cotización voluntaria RAIS
            if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
              this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
            }
            this.modelForm.tipoDeRenta684 = '2'; // 2 renta de trabajo con costo 
            if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
              this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[1].nombre;
            }

            // SI Cas 317 (Cotizaciones voluntarias RAIS Independiente)<= Cas 321(Limitante cotización RAIS Independiente), Cas 317 si no Cas 321;Limitante RAIS Independiente
            let cc317MenorIgualcc321 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.mdc.cc_id_317[indexIndependiente].v, this.mdc.cc_id_321[indexIndependiente].v);
            if (cc317MenorIgualcc321) {
              this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_317[indexIndependiente].v); //valor  //317
            }
            if (!cc317MenorIgualcc321) {
              this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_321[indexIndependiente].v); //valor  //321
            }

            // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexAsalariado].v : "0";//Límites RAIS  //691[indexAsalariado].v;//Límites RAIS  //691
            this.modelForm.seccionOrigen = "I2";
            this.modelForm.deshabilitarAcci = true;

            if (desdeSeccion) {
              this.dataSourceBody.push(this.modelForm);
            }
            else {
              this.addToModeloDesdeForm();
            }

            this.inicializeForm();
            indexTable++;

          //}

        }
      }
    }
  }


  //se remueve de ingresos no gravados 24/07/2024
  // private cargarDesdeVentaVivienda(desdeSeccion: boolean) {
  //   if (this.mdc.cc_id_522 != undefined
  //     && this.mdc.cc_id_522 != null) {

  //     const posicionesVentaVivienda = this.mdc.cc_id_522
  //       .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
  //       .filter(index => index !== -1);
  //     let indexTable = desdeSeccion ? this.dataSourceBody.length : this.mdc.cc_id_508.length;


  //     if (posicionesVentaVivienda.length > 0) {
  //       if (!desdeSeccion) { this.inicializeForm(); }
  //       for (let i = 0; i < posicionesVentaVivienda.length; i++) {
  //         const indexVentaVivienda = posicionesVentaVivienda[i];
  //         const existeValor = this.mdc.cc_id_681.some(item => item.v === this.mdc.cc_id_508[indexVentaVivienda].v);

  //         if (!existeValor) {
  //           this.modelForm.id = indexTable;
  //           this.modelForm.pagador = this.mdc.cc_id_508[indexVentaVivienda].v; //pagador  //309
  //           this.modelForm.origen = this.mdc.cc_id_302[indexVentaVivienda].v; //origen  //302  
  //           this.modelForm.concepto = '3'; //concepto: dominio 15
  //           if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
  //   this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
  // }
  //           this.modelForm.tipoDeRenta = '4'; // 2 renta no laboral
  //           if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
  //             this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2[0].nombre;
  //           }

  //           // SI Cas 522 (Cotizaciones voluntarias RAIS Independiente)<= Cas 321(Limitante cotización RAIS Independiente), Cas 522 si no Cas 321;Limitante RAIS Independiente
  //           let cc522MenorIgualcc321 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.mdc.cc_id_522[indexVentaVivienda].v, this.mdc.cc_id_321[indexVentaVivienda].v);
  //           if (cc522MenorIgualcc321) {
  //             this.modelForm.valor = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_522[indexVentaVivienda].v); //valor  //522
  //           }
  //           if (!cc522MenorIgualcc321) {
  //             this.modelForm.valor = this.dutilidades.obtenerFormatoMoneda(this.mdc.cc_id_321[indexVentaVivienda].v); //valor  //321
  //           }

  //           // this.modelForm.limitesRAIS = (this.mdc.cc_id_691 && this.mdc.cc_id_691.length>0)? this.mdc.cc_id_691[indexAsalariado].v : "0";//Límites RAIS  //691[indexAsalariado].v;//Límites RAIS  //691
  //           this.modelForm.seccionOrigen = "I2";
  //           this.modelForm.deshabilitarAcci = true;

  //           if (desdeSeccion) {
  //             this.dataSourceBody.push(this.modelForm);
  //           }
  //           else {
  //             this.addToModeloDesdeForm();
  //           }

  //           this.inicializeForm();
  //           indexTable++;

  //         }

  //       }
  //     }
  //   }
  // }






  protected initializeTablaDesdeSugerida() {
    let indexModel = this.mdc.cc_id_683.length;

    if (indexModel == 0) {
      const fieldsRecovery = ['VAR_1064'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      console.log(resData);

      if (resData) {
        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {
            // const existeValor = this.mdc.cc_id_683.some(item => item.v === this.data.sugerida[i].concepto);

            this.modelForm.id = indexModel;
            this.modelForm.pagador681 = resData[i].item.numNitInformante[j] + "/" + resData[i].item.nomRazonSocialInformante[j];//pagador  //681
            this.modelForm.origen = "0";//origen sugerida //682
            this.modelForm.concepto683 = "2";//concepto:  //683
            // this.modelForm.textoConcepto = this.listaConcepto[Number(this.data.sugerida[i])].nombre;
            this.modelForm.tipoDeRenta684 = "4"; //tipoDeRenta  //684 
            // this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta[Number(this.data.sugerida[i])].nombre;
            this.modelForm.valor685 = this.dutilidades.obtenerFormatoMoneda(String(resData[i].item.value[j])); //valor  //685
            // this.modelForm.limitesRAIS = this.data.sugerida[i].limitesRAIS; //Límites RAIS  //691

            // this.modelForm.idSugerida = this.data.sugerida[i].idSugerida;
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;


          }
        }
      }

    }
    console.log(this.data.sugerida)

    this.operacionCs686();
  }

  public editModeloDesdeForm() {

    this.mdc.cc_id_681[this.modelForm.id].v = this.modelForm.pagador681;//pagador  //681
    this.mdc.cc_id_682[this.modelForm.id].v = this.modelForm.origen;//origen  //682
    this.mdc.cc_id_683[this.modelForm.id].v = this.modelForm.concepto683;//concepto:  //683
    this.mdc.cc_id_684[this.modelForm.id].v = this.modelForm.tipoDeRenta684;//tipoDeRenta  //684 
    this.mdc.cc_id_685[this.modelForm.id].v = this.dutilidades.deshacerFormatoMoneda(this.modelForm.valor685);//valor  //685
    this.mdc.cc_id_687[this.modelForm.id].v = this.modelForm.seccionOrigen;//seccionOrigen  //687
    // this.mdc.cc_id_691[this.modelForm.id].v = this.mdc.cc_id_691[0].v;//limitesRAIS  //681

    /*  this.mdc.cc_id_676[this.modelForm.id].v = this.modelForm.vlg_RAIS_asal676;
     this.mdc.cc_id_677[this.modelForm.id].v = this.modelForm.vlg_RAIS_indep_cap677;
     this.mdc.cc_id_678[this.modelForm.id].v = this.modelForm.vlg_RAIS_rent_cap678;
     this.mdc.cc_id_679[this.modelForm.id].v = this.modelForm.vlg_RAIS_rent_no_lab679; */

  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.mdc.cc_id_681.push({ it: i, v: this.modelForm.pagador681 });//pagador  //681
    this.mdc.cc_id_682.push({ it: i, v: this.modelForm.origen });//origen  //682
    this.mdc.cc_id_683.push({ it: i, v: this.modelForm.concepto683 });//concepto:  //683
    this.mdc.cc_id_684.push({ it: i, v: this.modelForm.tipoDeRenta684 });//tipoDeRenta  //684 
    this.mdc.cc_id_685.push({ it: i, v: this.modelForm.valor685 });//valor  //685
    this.mdc.cc_id_687.push({ it: i, v: this.modelForm.seccionOrigen });//seccionOrigen  //687
    //this.mdc.cc_id_691.push({ it: i, v: this.mdc.cc_id_691[0].v });//limitesRAIS  //691

    /*  this.mdc.cc_id_676.push({ it: i, v: this.modelForm.vlg_RAIS_asal676 });//limitesRAIS  //691
     this.mdc.cc_id_677.push({ it: i, v: this.modelForm.vlg_RAIS_indep_cap677 });//limitesRAIS  //691
     this.mdc.cc_id_678.push({ it: i, v: this.modelForm.vlg_RAIS_rent_cap678 });//limitesRAIS  //691
     this.mdc.cc_id_679.push({ it: i, v: this.modelForm.vlg_RAIS_rent_no_lab679 });//limitesRAIS  //691 */

  }


  public deleteOnModel(index: number) {
    this.mdc.cc_id_681.splice(index, 1);//pagador  //681
    this.mdc.cc_id_682.splice(index, 1);//origen  //682
    this.mdc.cc_id_683.splice(index, 1);//concepto:  //683
    this.mdc.cc_id_684.splice(index, 1);//tipoDeRenta  //684 
    this.mdc.cc_id_685.splice(index, 1);//valor  //685
    this.mdc.cc_id_687.splice(index, 1);//seccionOrigen  //687
    //this.mdc.cc_id_691.splice(index, 1);//limitesRAIS  //691
    /*   this.mdc.cc_id_676.splice(index, 1)
      this.mdc.cc_id_677.splice(index, 1)
      this.mdc.cc_id_678.splice(index, 1)
      this.mdc.cc_id_679.splice(index, 1) */

    //reenumerear it
    for (let i = 0; i < this.mdc.cc_id_683.length; i++) {
      this.mdc.cc_id_681[i].it = i + 1;
      this.mdc.cc_id_682[i].it = i + 1;
      this.mdc.cc_id_683[i].it = i + 1;
      this.mdc.cc_id_684[i].it = i + 1;
      this.mdc.cc_id_685[i].it = i + 1;
      this.mdc.cc_id_687[i].it = i + 1;
      //this.mdc.cc_id_691[i].it = i + 1;

      /* this.mdc.cc_id_676[i].it = i + 1;
      this.mdc.cc_id_677[i].it = i + 1;
      this.mdc.cc_id_678[i].it = i + 1;
      this.mdc.cc_id_679[i].it = i + 1; */

    }
  }

  public deleteOnModelOtraSeccion(index1: number) {
    const index = this.mdc.cc_id_681.findIndex(item=>item.it == index1);
    if (index !== -1) {
      this.mdc.cc_id_681.splice(index, 1);//pagador  //681
      this.mdc.cc_id_682.splice(index, 1);//origen  //682
      this.mdc.cc_id_683.splice(index, 1);//concepto:  //683
      this.mdc.cc_id_684.splice(index, 1);//tipoDeRenta  //684 
      this.mdc.cc_id_685.splice(index, 1);//valor  //685
      this.mdc.cc_id_687.splice(index, 1);//seccionOrigen  //687
    }
  }

  public validateFormCompleted(): boolean {
    return this.modelForm.concepto683 == undefined || this.modelForm.concepto683 == null || this.modelForm.concepto683.trim() == "" ||

      this.modelForm.valor685 == undefined || this.modelForm.valor685 == "0" ||
      this.modelForm.origen == undefined || this.modelForm.origen == null
  }

  public redondearFormData() {

    this.modelForm.valor685 = this.dutilidades.redondearValorMoneda(this.modelForm.valor685.toString(), true);

  }

  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();

    this.operacionCS691();

    // limita valor a Limite RAIS
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,
      this.mdc.cs_id_691, '0')) {

      if ((this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,
        this.modelForm.valor685, this.mdc.cs_id_691)||
        (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.modelForm.concepto683, '4')))
      ) {
        this.modelForm.valor685 =
          this.dutilidades.redondearValorMoneda(this.modelForm.valor685.toString());
      } else {
        this.modelForm.valor685 =
          this.dutilidades.redondearValorMoneda(this.mdc.cs_id_691.toString());

      }
    }


    this.reloadSelArticulos(conservarArt);
  }

  private operacionCS691()/* : Promise<void> */ {


    /* return new Promise((resolve) => {
 */
    console.log('=====================================modelForm:', this.modelForm);
    let i = this.modelForm.id + 1;
    const existeConcep3 = this.mdc.cc_id_683.some(item => item.v == "3")/*  || this.dataSourceBody.some(item => item.limitesRAIS691=="3") */;
    const existeRenta1234 = this.mdc.cc_id_684.some(item => item.v == "1" || item.v == "2" || item.v == "3" || item.v == "4");

    this.modelForm.limitesRAIS691 = '0';
    let suma691 = "0";
    if (existeConcep3 && existeRenta1234) {
      let suma569 = "0";
      let suma538 = "0";
      if (this.mdc.cc_id_569 && this.mdc.cc_id_569.length > 0) {

        for (let i = 0; i < this.mdc.cc_id_569.length; i++) {
          suma569 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_569[i].v, suma569);
        }

      }
      if (this.mdc.cc_id_538 && this.mdc.cc_id_538.length > 0) {
        for (let i = 0; i < this.mdc.cc_id_538.length; i++) {
          suma538 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_538[i].v, suma538);
        }
      }

      let listaCasillas = [
        this.mdc.cs_id_280,//total ¿Fue asalariado o funcionario público? 
        this.mdc.cs_id_305,//total ¿Fue trabajador independiente? 
        this.mdc.cs_id_328,//total RENTAS DE CAPITAL
        this.mdc.cs_id_372,//total RETIROS AFC, FVP O AVC
        this.mdc.cs_id_343,//total RENTAS NO LABORALES
        this.mdc.cs_id_355,//total PENSIONES
        this.mdc.cs_id_494,//total DIVIDENDOS Y PARTICIPACIONES
        this.mdc.cs_id_509,//VALOR VENTA CASA DE HABITACIÓN 
        this.mdc.cs_id_586,//total HERENCIAS, DONACIONES, DIVORCIO O PORCION CONYUGAL
        this.mdc.cs_id_608,//total LOTERÍAS
        this.mdc.cs_id_626,//total RENTAS PÁSIVAS
        this.mdc.cs_id_648,//total OTROS INGRESOS
        this.mdc.cs_id_763,//total RENTAS EXENTAS ESPECIALES SIN LIMITE
      ];


      //suma  la lista de casillas
      let sumaListaCasillas = "0";
      for (let index = 0; index < listaCasillas.length; index++) {
        sumaListaCasillas = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.SUMA, listaCasillas[index], sumaListaCasillas);
      }

      const sumaCompuestas = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, suma569, suma538);
      const sumaCompuestasSimples = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, sumaCompuestas, sumaListaCasillas);

      // Recorrido casillas 623
      let suma623 = "0";
      if (this.mdc.cc_id_623 && this.mdc.cc_id_623.length > 0) {
        for (let index = 0; index < this.mdc.cc_id_623.length; index++) {

          if (this.mdc.cc_id_623[index]) {
            if (this.mdc.cc_id_623[index].v == '3' ||
              this.mdc.cc_id_623[index].v == '4'
            ) {
              suma623 = this.dutilidades.ejecutarOperacion(
                DTipoOperacionAritmetica.SUMA, this.mdc.cc_id_624[index].v,
                suma623);
            }
          }
        };
      }

      const suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, sumaCompuestasSimples, suma623);


      let resultado25pct = this.calc.mult(suma1, '0.25');


      let uvt2500 = Number(this.uvt) * 2500;
      let limRAIS = "0";
      if (this.dutilidades.validacionesNumericas(
        DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,
        resultado25pct,
        uvt2500.toString())) {
        limRAIS = resultado25pct;
      } else {
        limRAIS = uvt2500.toString();

      }

      // this.mdc.cs_id_691 = this.modelForm.limitesRAIS;
      //this.mdc.cc_id_691.push({ it: i, v: this.modelForm.limitesRAIS691 });
      this.mdc.cs_id_691 = limRAIS;

    }
  }

  private operacionCS676() {
    const existeRenta1 = this.mdc.cc_id_684.some(item => item.v == "1");
    let suma685_31 = "0";
    let suma685_32 = "0";
    let suma685_33 = "0";
    let suma685_34 = "0";
     
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_683.length; i++) {
      if (this.model.doc.cuerpo.cc_id_683[i].v == "3") {
        if (this.model.doc.cuerpo.cc_id_684[i].v == "1") {
          suma685_31 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_685[i].v, suma685_31);
        } else if (this.model.doc.cuerpo.cc_id_684[i].v == "2") {
          suma685_32 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_685[i].v, suma685_32);
        } else if (this.model.doc.cuerpo.cc_id_684[i].v == "3") {
          suma685_33 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_685[i].v, suma685_33);
        } else if (this.model.doc.cuerpo.cc_id_684[i].v == "4") {
          suma685_34 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_685[i].v, suma685_34);
        }
      }
    } 
    let array685 = [suma685_31, suma685_32, suma685_33, suma685_34];
    let sumaArray685 = "0";
    for (let index = 0; index < array685.length; index++) {
      sumaArray685 = this.dutilidades.ejecutarOperacion(
        DTipoOperacionAritmetica.SUMA, array685[index], sumaArray685);
    }

    let valRAISlimitante=this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, sumaArray685, this.mdc.cs_id_691)?sumaArray685:this.mdc.cs_id_691;
 
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,suma685_31,valRAISlimitante)) {
      this.mdc.cs_id_676 = suma685_31;
      valRAISlimitante = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,valRAISlimitante, suma685_31);
    } else {
      // this.mdc.cs_id_676 = this.mdc.cs_id_691;
      this.mdc.cs_id_676 =valRAISlimitante ;
      valRAISlimitante="0";
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,suma685_32,valRAISlimitante)) {
      this.mdc.cs_id_677 = suma685_32;
      valRAISlimitante = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,valRAISlimitante, suma685_32);
    } else {
      // this.mdc.cs_id_676 = this.mdc.cs_id_691;
      this.mdc.cs_id_677 =valRAISlimitante ;
      valRAISlimitante="0";
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,suma685_33,valRAISlimitante)) {
      this.mdc.cs_id_678 = suma685_33;
      valRAISlimitante = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,valRAISlimitante, suma685_33);
    } else {
      // this.mdc.cs_id_676 = this.mdc.cs_id_691;
      this.mdc.cs_id_678 =valRAISlimitante ;
      valRAISlimitante="0";
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,suma685_34,valRAISlimitante)) {
      this.mdc.cs_id_679 = suma685_34;
      valRAISlimitante = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,valRAISlimitante, suma685_34);
    } else {
      // this.mdc.cs_id_676 = this.mdc.cs_id_691;
      this.mdc.cs_id_679 =valRAISlimitante ;
      valRAISlimitante="0";
    }


  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();

      if (this.operacionTabla == this.OPERACION_EDITAR) {

        this.modelForm.seccionOrigen = "";

        if (this.listaConcepto && this.listaConcepto.find(item => item.valor == this.modelForm.concepto683)) {
          this.modelForm.textoConcepto = this.listaConcepto.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
        }
        if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
          this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2.find(item => item.valor.toString() == this.modelForm.tipoDeRenta684).nombre;
        }

        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });

      } else if (this.operacionTabla == this.OPERACION_AGREGAR) { //agregando nuevo por el contribuyente
        this.modelForm.id = this.dataSourceBody.length;
        this.modelForm.origen = '2';

        if (this.listaConcepto2 && this.listaConcepto2.find(item => item.valor == this.modelForm.concepto683)) {
          this.modelForm.textoConcepto = this.listaConcepto2.find(item => item.valor.toString() == this.modelForm.concepto683).nombre;
        }
        if (this.listaTipoDeRenta2 && this.listaTipoDeRenta2.length > 0) {
          this.modelForm.textoTipoDeRenta = this.listaTipoDeRenta2.find(item => item.valor.toString() == this.modelForm.tipoDeRenta684).nombre;
        }
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs686();
      this.operacionCS691();
      this.operacionCS676();

      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs686();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando

      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }


  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  /*   public validateRbQuestions(val: string) {
      this.modelForm.aplicoArt73 = val;
      this.calcularValoresForm();
    } */

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /*  public validateStepHabilitado(indexS:number):boolean{
     let habilitado = true;
     return habilitado;
   } */

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /* public validateBtnRightActive(){

  } */

  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.mdc[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.mdc[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.mdc[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.mdc[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs686();

    this.dialogRef.close("");
  }

  reset() {
    console.log('reset en ingresos no gravados');
    let listaEliminar = [];
    for (let index = 0; index < this.mdc.cc_id_687.length; index++) {
      if (this.calc.esDif(this.mdc.cc_id_687[index].v, '')) {
        listaEliminar.push(this.mdc.cc_id_687[index].it);
      }
    }
    listaEliminar.forEach(it => this.deleteOnModelOtraSeccion(Number(it)));
    this.dataSourceBody=[];
    //this.initializeTablaDesdeModelo();
    this.cargarDatosOtrosModales(false);
    // this.saveModel.emit(true);
  }



  public guardar(desdeSeccion = false) {
    
    //Limpiar modelo y agregar el contenido de la tabla

    this.mdc.cc_id_681 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.modelForm.valor685 = this.dutilidades.deshacerFormatoMoneda(this.modelForm.valor685);
      console.log(this.modelForm);
      this.addToModeloDesdeForm();
    }

    this.operacionCS691();
    this.operacionCS676();

    this.saveModel.emit(true);

    if (!desdeSeccion) {
      this.closeModal();
    }

    console.log('guardar en ingresos no gravados:', this.model);

  }


  public borrarTabla() {
    this.dataSourceBody = [];
  }



}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component.ts